import { Button, Container, TextField, Typography } from "@mui/material";
import Logo from "../assets/Logo.png";
import React from "react";
import { changePassword } from "../actions/Auth";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import "./UserAccountPage.css";
export default function ChangePassword() {
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);
  const [changePasswordData, setChangePasswordData] = React.useState({
    passwordCurrent: "",
    password: "",
    passwordConfirm: "",
  });
  const [error, setError] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(false);
  const dispatch = useDispatch();
  function sendData() {
    if (
      !changePasswordData.passwordCurrent &&
      !changePasswordData.password &&
      !changePasswordData.passwordConfirm
    ) {
      setError("Please fill all required fields");
      return;
    }
    if (changePasswordData.password !== changePasswordData.passwordConfirm) {
      setError("Password do not match");
      return;
    }

    const passwordPattern =
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;
    if (!passwordPattern.test(changePasswordData.password)) {
      setError(
        "Password should include uppercase letters, lowercase letters, numbers, and characters, and also be at least 8 characters long"
      );
      return;
    }
    setError("");
    setIsLoading(true);
    setErrorMessage(true);
    // Simulating an asynchronous password change process
    dispatch(changePassword(changePasswordData));
    setTimeout(() => {
      setIsLoading(false);
      setChangePasswordData({
        password: "",
        passwordConfirm: "",
        passwordCurrent: "",
      });
      // Continue with form submission or further processing
      // ...
    }, 3000);
  }

  const message = useSelector((state) => state);

  return (
    <Container
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "80vh",
        width: "100%",
      }}>
      <div
        style={{
          // marginTop: "60px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          rowGap: "30px",
          width: "100%",
          marginLeft: "20vw",
        }}>
        {errorMessage && (
          <Stack sx={{ width: "100%" }} spacing={2}>
            {message.auth.changePasswordError && (
              <Alert severity='error'>
                Error:{message.auth.changePasswordError}
              </Alert>
            )}
            {message.auth.changePasswordSuccess && (
              <Alert severity='success'>
                {message.auth.changePasswordSuccess}
              </Alert>
            )}
          </Stack>
        )}
        <img
          src={Logo}
          width={100}
          height={"auto"}
          alt='Nyankomasi-Ahenkuro Rural Bank PLC-logo'
        />
        <Typography
          variant='h6'
          style={{ color: mode === "dark" ? "#ccc" : "#000000" }}>
          Change your account password
        </Typography>
        <TextField
          required
          style={{
            width: "100%",
            backgroundColor: "#ccc",
            borderRadius: "5px",
          }}
          type='text'
          label='Old password'
          value={changePasswordData.passwordCurrent}
          onChange={(e) =>
            setChangePasswordData({
              ...changePasswordData,
              passwordCurrent: e.target.value,
            })
          }
        />
        <TextField
          required
          type='text'
          style={{
            width: "100%",
            backgroundColor: "#ccc",
            borderRadius: "5px",
          }}
          label='New password'
          value={changePasswordData.password}
          onChange={(e) =>
            setChangePasswordData({
              ...changePasswordData,
              password: e.target.value,
            })
          }
        />
        <div
          style={{ display: "flex", flexDirection: "column", width: "100%" }}>
          <TextField
            required
            type='text'
            label='Confirm New password'
            value={changePasswordData.passwordConfirm}
            style={{
              width: "100%",
              backgroundColor: "#ccc",
              borderRadius: "5px",
            }}
            onChange={(e) =>
              setChangePasswordData({
                ...changePasswordData,
                passwordConfirm: e.target.value,
              })
            }
          />

          <span style={{ color: "red", fontSize: "12px", width: "250px" }}>
            {error}
          </span>
        </div>

        <Button
          onClick={sendData}
          size='small'
          variant='contained'
          className={isLoading ? "loading" : ""}>
          {isLoading ? "Changing..." : "Submit"}
        </Button>
      </div>
    </Container>
  );
}
